import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import ApproveRepository from '../Repositories/ApproveRepository'


class ApproveBloc {

    regionCountryChannel = new Subject();
    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    detailChannel = new Subject();
    approveChannel = new Subject();
    repository = new ApproveRepository()

    constructor() {
        this.approveChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionCountry = async (query) => {
        this.regionCountryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCountry(query).then((result) => {
            this.regionCountryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCountryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionProvince = async (query) => {
        this.regionProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionProvince(query).then((result) => {
            this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionCity = async (query) => {
        this.regionCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCity(query).then((result) => {
            this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchApprove = async (query) => {
        this.approveChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchApprove(query).then((result) => {
            this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.approveChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default ApproveBloc